import React from 'react';

import { useOfficeDrones } from '@/components/Ajax';

// get list of available languages for TA
export default function useGetTextAnalyticsLanguages() {
	return useOfficeDrones('/textanalytics/config/languages', {}, {}, 'get');
}
